export default __webpack_public_path__ + "static/media/calendar.c2aea4fb.svg";